import { formatCurrencyAmount } from "@/components/pages/services/utils/priceFormatting";

/** Formats a numeric EUR amount for partner tables and detail (no locale grouping). */
export function formatGuesteriaPartnerRevenueEur(value: number): string {
  return formatPartnerRevenueValue(value, "EUR");
}

export function formatPartnerRevenueValue(
  value: number,
  currency: string,
): string {
  return formatCurrencyAmount(value, currency);
}
